<template>
	<div class="w-full">
		<GridLayout
			:sidebar-state="false"
			right-title="PACIENTES"
		>
			<template #right-tool-bar>
				<ToolBar class="flex gap-5 justify-between">
					<div class="w-4/12 form-group m-0 position-relative">
						<SearchGroup
							:search="search"
							placeholder="BUSCAR POR NOME, CPF, RG OU RH"
							@search="
								search = $event
								GetPatients(true)
							"
						/>
					</div>

					<button
						class="btn btn-tool"
						@click="showPatientModal = true"
					>
						<i class="fal fa-plus mx-2 font-32"></i>
					</button>
				</ToolBar>
			</template>
			<template #right-content>
				<NewDatatable
					v-model="patients"
					type="search"
					:headers="headers"
					:search="search"
					:row-colors="{
						unknown: 'var(--emergencyBackgroundColor)',
						newborn: 'var(--priorityBackgroundColor)',
						normal: 'var(--conventionalColor)',
					}"
					row-type-key="state_type"
					:lazy-loading="true"
					:total="total"
					max-height="38.7rem"
					@load-table="UpdateTable"
					@click="EditPatient"
				>
					<template #row="{ item }">
						<div class="datatable-cell">
							<b>{{ item.nome_paciente.toUpperCase() }}</b>
						</div>
						<div class="datatable-cell">
							{{ ParseCPF(item.cpf) || '-' }}
						</div>
						<div class="datatable-cell">
							{{
								item.rg && item.rg_uf
									? item.rg + item.rg_uf
									: '-'
							}}
						</div>
						<div class="datatable-cell">
							{{ item.sus || '-' }}
						</div>
						<div class="datatable-cell">
							{{ item.rh || '-' }}
						</div>
						<div class="datatable-cell">
							{{ ParseDate(item.created_at) }}
						</div>
						<div class="datatable-cell">
							<span
								class="state-badge"
								:class="item.state.type"
							>
								{{ item.state.label }}
							</span>
						</div>
					</template>
				</NewDatatable>

				<PatientModal
					v-if="showPatientModal"
					@close="showPatientModal = false"
					@new="NewPatient"
				/>
			</template>
			<template #right-info-bar>
				<InfoBar class="flex justify-end">
					<div class="flex items-center gap-2">
						<span>EXIBIDOS: </span>
						<b>{{ patients.length }}</b>
						<span>DE</span>
						<span>
							<b>{{ total }}</b>
						</span>
					</div>
				</InfoBar>
			</template>
		</GridLayout>
	</div>
</template>

<script>
	const _ = require('lodash')
	const moment = require('moment')

	import DataTables from '../shared/DataTables'

	import Swal from 'sweetalert2'

	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'Patients',
		components: {
			DataTables,
		},
		props: {},
		data() {
			return {
				patients: [],
				search: '',
				limit: 200,
				offset: 0,
				total: 0,
				total_filtered: 0,
				form_type: 'pre',
				headers: [
					{ text: 'NOME', value: 'nome_paciente' },
					{ text: 'CPF', value: 'cpf', width: '8vw' },
					{ text: 'RG', value: 'rg', width: '9vw' },
					{ text: 'CNS', value: 'sus', width: '9vw' },
					{ text: 'RH', value: 'rh', width: '10vw' },
					{
						text: 'DATA DE CADASTRO',
						value: 'created_at',
						width: '10vw',
					},
					{
						text: 'STATUS',
						value: 'status',
						width: '10vw',
					},
				],
				showPatientModal: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			Previous() {
				this.$router.push({ name: 'Home' })
			},
			ParseCPF(value) {
				if (value) {
					let cpf = ''

					cpf = value.replace(/[^\d]/g, '')

					return cpf.replace(
						/(\d{3})(\d{3})(\d{3})(\d{2})/,
						'$1.$2.$3-$4'
					)
				}

				return ''
			},
			ParseDate(date) {
				let data = date.substr(0, 10)

				data = data.split('-').reverse().join('/')

				return data
			},
			EditPatient(patient) {
				this.$router.push({
					name: 'PatientPanel',
					params: {
						patient_id: patient.id,
					},
				})
			},
			async GetPatients(clear = true) {
				this.StartLoading()

				this.offset = clear ? 0 : this.offset
				this.patients = clear ? [] : this.patients

				return await window.api
					.call('post', '/get-patients', {
						account_id: `${this.requester_selected_id}`,
						offset: this.offset,
						limit: this.limit,
						search: this.search,
					})
					.then(({ data }) => {
						if (data.response) {
							this.total = data.total
							this.total_filtered = data.total_filtered

							const mapped_patients = data.patients.map(p => {
								const state = this.GetPatientState(p)
								return {
									...p,
									cpf: p.cpf == 'DESCONHECIDO' ? null : p.cpf,
									rg: p.rg == 'DESCONHECIDO' ? null : p.rg,
									rg_uf:
										p.rg_uf == 'DESCONHECIDO'
											? null
											: p.rg_uf,
									sus: p.sus == 'DESCONHECIDO' ? null : p.sus,
									rh: !p.rh ? null : p.rh,
									state,
									state_type: state.type,
								}
							})

							const ordered_patients = this.search
								? mapped_patients
								: _.orderBy(
										mapped_patients,
										['desconhecido', 'nome_paciente'],
										['asc', 'asc']
								  )

							this.patients = this.patients.length
								? [...this.patients, ...ordered_patients]
								: ordered_patients
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			GetPatientState(patient) {
				let state = {
					type: 'normal',
					label: 'CADASTRADO',
				}

				if (patient.desconhecido) {
					state = {
						type: 'unknown',
						label: 'DESCONHECIDO',
					}
				} else if (patient.newborn) {
					state = {
						type: 'newborn',
						label: 'RECÉM-NASCIDO',
					}
				}

				return state
			},
			NewPatient(patient) {
				this.patients.push(patient)

				this.search = patient.nome_paciente.toLowerCase()
			},
			async UpdateTable() {
				const vm = this

				const Toast = Swal.mixin({
					title: 'NÃO HÁ MAIS PACIENTES A SEREM CARREGADOS',
					toast: true,
					position: 'top',
					icon: 'info',
					timer: 4000,
					timerProgressBar: true,
					customClass: {
						container: 'themed',
					},
				})

				if (vm.search) {
					if (vm.patients.length >= vm.total_filtered) {
						Toast.fire()

						return
					}
				} else {
					if (vm.patients.length >= vm.total) {
						Toast.fire()

						return
					}
				}

				vm.offset += vm.limit

				await vm.GetPatients(false)
			},
		},
		async mounted() {
			await this.GetPatients()

			window.jQuery('#patient-modal').on('shown', () => {
				window.jQuery('body').addClass('modal-open')
			})
		},
	}
</script>

<style lang="scss" scoped>
	.state-badge {
		// font-family: 'Inter', sans-serif;
		font-size: 1.1rem;
		font-weight: 900;

		&.unknown {
			color: var(--emergencyBackgroundColor);
		}
		&.newborn {
			color: var(--priorityBackgroundColor);
		}
		&.normal {
			color: var(--conventionalColor);
		}
	}
</style>
